import reportSchedulesAPI from '../../api/reportSchedules';

const SET_UI_FLAG = 'SET_REPORT_SCHEDULES_UI_FLAG';
const SET_REGISTRY = 'SET_REPORT_SCHEDULES_REGISTRY';
const SET_SCHEDULES = 'SET_REPORT_SCHEDULES';
const SET_ACCOUNT_USERS = 'SET_REPORT_SCHEDULE_ACCOUNT_USERS';
const SET_INBOXES = 'SET_REPORT_SCHEDULE_INBOXES';
const UPSERT_SCHEDULE = 'UPSERT_REPORT_SCHEDULE';
const REMOVE_SCHEDULE = 'REMOVE_REPORT_SCHEDULE';

export const state = {
  registry: [],
  schedules: [],
  accountUsers: [],
  inboxes: [],
  uiFlags: {
    fetchingList: false,
    savingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getRegistry: $state => $state.registry,
  getSchedules: $state => $state.schedules,
  // A report can hold one schedule per frequency (daily, weekly, monthly).
  getSchedulesByKey: $state => reportKey =>
    $state.schedules.filter(schedule => schedule.report_key === reportKey),
  getAccountUsers: $state => $state.accountUsers,
  getInboxes: $state => $state.inboxes,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async get({ commit }) {
    commit(SET_UI_FLAG, { fetchingList: true });
    try {
      const { data } = await reportSchedulesAPI.get();
      commit(SET_REGISTRY, data.registry || []);
      commit(SET_SCHEDULES, data.schedules || []);
      commit(SET_ACCOUNT_USERS, data.account_users || []);
      commit(SET_INBOXES, data.inboxes || []);
    } finally {
      commit(SET_UI_FLAG, { fetchingList: false });
    }
  },

  async upsert({ commit }, schedule) {
    commit(SET_UI_FLAG, { savingItem: true });
    try {
      const { data } = schedule.id
        ? await reportSchedulesAPI.updateById(schedule.id, schedule)
        : await reportSchedulesAPI.upsert(schedule);
      commit(UPSERT_SCHEDULE, data);
      return data;
    } finally {
      commit(SET_UI_FLAG, { savingItem: false });
    }
  },

  async delete({ commit }, id) {
    commit(SET_UI_FLAG, { deletingItem: true });
    try {
      await reportSchedulesAPI.delete(id);
      commit(REMOVE_SCHEDULE, id);
    } finally {
      commit(SET_UI_FLAG, { deletingItem: false });
    }
  },

  // eslint-disable-next-line no-unused-vars
  downloadSample(_, reportKey) {
    return reportSchedulesAPI.downloadSample(reportKey);
  },
};

export const mutations = {
  [SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [SET_REGISTRY]($state, data) {
    $state.registry = data;
  },
  [SET_SCHEDULES]($state, data) {
    $state.schedules = data;
  },
  [SET_ACCOUNT_USERS]($state, data) {
    $state.accountUsers = data;
  },
  [SET_INBOXES]($state, data) {
    $state.inboxes = data;
  },
  [UPSERT_SCHEDULE]($state, schedule) {
    const index = $state.schedules.findIndex(item => item.id === schedule.id);
    if (index === -1) {
      $state.schedules.push(schedule);
    } else {
      $state.schedules.splice(index, 1, schedule);
    }
  },
  [REMOVE_SCHEDULE]($state, id) {
    $state.schedules = $state.schedules.filter(item => item.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
